<template>
  <div class="main-container">
    <Tabs v-model="tabVal">
      <TabPane label="人身个险" name="1"></TabPane>
      <TabPane label="团财" name="2"></TabPane>
    </Tabs>

    <Button class="back-btn" type="primary" ghost @click="back()">返回</Button>

    <insureOrder v-if="tabVal == '1'"></insureOrder>
    <groupOrder v-if="tabVal == '2'"></groupOrder>
  </div>
</template>

<script>
import insureOrder from './insureOrder';
import groupOrder from './groupOrder';
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  components: {
    insureOrder,
    groupOrder
  },
  data() {
    return {
      tabVal: '1'
    };
  }
};
</script>

<style lang="scss" scoped>
.back-btn {
  position: absolute;
  right: 20px;
  z-index: 1;
  top: 15px;
}
</style>
